export default __webpack_public_path__ + "static/ui-hacks@2x-33e05737bf60c6c5aa9405b92bbee16f.png";